var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAgodaCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "buwl9z7fha",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1023 -116) translate(1023 116)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u5e14ryoqb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#buwl9z7fha"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#buwl9z7fha"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#u5e14ryoqb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E03534",
    d: "M1 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1",
    transform: "translate(5 5) translate(0 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB943A",
    d: "M4.25 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1",
    transform: "translate(5 5) translate(0 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CA863",
    d: "M7.5 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1",
    transform: "translate(5 5) translate(0 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A579C",
    d: "M10.75 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1",
    transform: "translate(5 5) translate(0 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D7CB4",
    d: "M14 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1",
    transform: "translate(5 5) translate(0 13)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8D8E92",
    d: "M9.273 5.292c-.485.163-.97.327-1.485.424-.636.164-1.091.262-1.364.327-.272.065-.515.228-.727.424-.242.229-.364.522-.333.849 0 .359.151.718.424.979.303.26.667.424 1.06.391.425 0 .88-.097 1.243-.326.364-.196.667-.49.848-.848.243-.588.364-1.24.303-1.86l.03-.36zm.09 3.59c-.484.425-1.06.784-1.636 1.045-.575.228-1.151.359-1.757.359-.546 0-1.091-.13-1.576-.392-.424-.228-.788-.587-1.03-1.044C3.12 8.425 3 7.936 3 7.446c0-.652.212-1.273.606-1.762.455-.522 1.03-.849 1.667-.98l1.09-.26c.576-.131 1.092-.229 1.516-.36.424-.097.879-.228 1.363-.391 0-.522-.12-1.012-.363-1.469-.212-.293-.667-.457-1.364-.457-.454-.032-.909.066-1.333.261-.303.196-.576.457-.758.784-.212.359-.363.587-.454.685-.152.13-.364.196-.576.163-.242 0-.485-.098-.667-.26-.182-.164-.303-.425-.272-.686 0-.457.151-.914.424-1.273.363-.49.848-.849 1.394-1.044C6 .103 6.788-.028 7.576.005c.818-.033 1.636.098 2.394.392.545.228 1 .652 1.242 1.24.273.718.394 1.468.364 2.252v2.839c0 .49.09.98.212 1.469.09.326.182.653.212.979 0 .261-.121.522-.333.718-.212.196-.485.327-.758.327s-.515-.131-.697-.36c-.273-.326-.545-.685-.727-1.044l-.121.065z",
    transform: "translate(5 5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAgodaCircle);
export default __webpack_public_path__ + "static/media/IcoAgodaCircle.1c83be68328e19b8fc92e66c1ec401a8.svg";
export { ForwardRef as ReactComponent };